import React, { useCallback, useRef, useState } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';

// components
import { chattingTableFilter02 } from '../../components/ChattingComponents/ChattingTableFilter';
import RefreshCheckApi from '../../communication_system/axios_apis/refresh_check/refresh_check_api';

// design-components
import MainTable from '../../designComponents/tables/MainTable';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';
import FlexMainWrapper, { Wrapper02 } from '../../designComponents/wrappers/FlexMainWrapper';

// utils
import { availFilter, sexFilter } from '../../utils/textFilter';
import SearchbarWithDropdown from '../../designComponents/searchbars/SearchbarWithDropdown';

import { MainButton } from '../../designComponents/buttons/Buttons';
import DatingChattingCreateModal from '../../components/Chatting/DatingChattingCreateModal';
import DatingChattingDetailModal from '../../components/Chatting/DatingChattingDetailModal';

export const createFriendChatRequest = (selectedUsers) => RefreshCheckApi.post('/v2/chatting', {
    send_user_id: selectedUsers[0].id,
    receive_user_id: selectedUsers[1].id,
});

/** 채팅페이지 */
const Chatting = () => {
    const [param, setParam] = useState({
        order: -1,
        chatType: [1, 4],
    });
    const [searchType, setSearchType] = useState(1);
    const [searchText, setSearchText] = useState('');

    const [chatParams, setChatParams] = useState({ toggle: false });
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [detailModalVisible, setDetailModalVisible] = useState(false);
    const [selectedChatItem, setSelectedChatItem] = useState(null);

    const ref = useRef();
    const tableRef = useRef();

    /** 1: 친구, 2: 모임, 3: 모임단체 */
    const callApi02 = async (page, param) => {
        try {
            const input = {
                page: page,
                size: 10,
                ...param,
            };
            if (searchType === 1) {
                input.phone = searchText;
            } else if (searchType === 2) {
                input.name = searchText;
            } else if (searchType === 3) {
                input.nickName = searchText;
            }
            const response = await RefreshCheckApi.post(`/v2/chatting/list/1`, input);
            return response.data;
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const onCreateChatting = async (selectedUsers) => {
        const response = await createFriendChatRequest(selectedUsers);
        if (!response?.data) {
            throw new Error('create fail');
        }
        ref?.current?.refresh();
    };

    const onClickChatRow = (item) => async () => {
        setSelectedChatItem(item);
        setDetailModalVisible(true);
    };

    return (
        <Wrapper02>
            <MainPageTitle text={'친구 대화'} onClick={() => ref?.current?.refresh()} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <SearchbarWithDropdown
                    list={[
                        { id: 1, title: '휴대폰번호', value: 1 },
                        { id: 2, title: '이름', value: 2 },
                        { id: 3, title: '닉네임', value: 3 },
                    ]}
                    resetThenSet={useCallback((item) => {
                        setSearchType(item.value);
                    }, [])}
                    onChangeSubmit={(e) => {
                        e.preventDefault();
                        ref?.current?.refresh();
                    }}
                    searchText={searchText}
                    onChangeInput={(e) => {
                        const value = e.target.value;
                        setSearchText(searchType === 1 ? value.replaceAll('-', '') : value);
                    }}
                    setSearchText={setSearchText}
                />
                <MainButton text={'채팅 생성'} onClick={() => setCreateModalVisible(true)} />
            </div>
            <DatingChattingCreateModal visible={createModalVisible} onClose={() => setCreateModalVisible(false)} onCreate={onCreateChatting} />
            <DatingChattingDetailModal
                visible={detailModalVisible}
                chatItem={selectedChatItem}
                onClose={() => {
                    setDetailModalVisible(false);
                    setSelectedChatItem(null);
                }}
                onSuccess={() => {
                    ref?.current?.refresh();
                }}
            />

            <FlexMainWrapper>
                <MainTable
                    buttonComponents={({ checkItems }) => {}}
                    ref={ref}
                    tableStyle={{ width: chatParams.toggle ? '70%' : '98%' }}
                    tableRef={tableRef}
                    loadingText={'채팅 내역을 불러오고 있습니다.'}
                    headerData={chattingTableFilter02}
                    checkID={'id'}
                    param={param}
                    checkAble={false}
                    setParam={setParam}
                    toggleBlur={true}
                    callApi={callApi02}
                    onClickRowItem={onClickChatRow}
                    tbodyRenderItem={(key, value, data) => {
                        if (key === 'avail_yn') return availFilter(value);
                        if (key === 'user_sex' || key === 'target_user_sex') return sexFilter(value);
                        if (!key) return <ArrowRightOutlined />;
                        if (key === 'disable_button') return availFilter(data.avail_yn, '활성화', '비활성화', { Y: { width: '100%' }, N: { width: '100%' } });
                        if (key === 'from') {
                            return (
                                <span>
                                    {data?.from_name}/{data?.from_nick_name}/{sexFilter(data?.from_sex)} {!data.from_avail ? '(나감)' : ''}
                                </span>
                            );
                        }
                        if (key === 'to') {
                            return (
                                <span>
                                    {data?.to_name}/{data?.to_nick_name}/{sexFilter(data?.to_sex)} {!data.to_avail ? '(나감)' : ''}
                                </span>
                            );
                        }
                        if (key === 'report' && (data.from_reported || data.to_reported)) {
                            return (
                                <span>
                                    {data.from_reported ? `${data.to_nick_name} → ${data.from_nick_name} - ${data.from_reported}` : ''}
                                    {data.to_reported ? `${data.from_nick_name} → ${data.to_nick_name} - ${data.to_reported}` : ''}
                                </span>
                            );
                        }
                        return value;
                    }}
                />
            </FlexMainWrapper>
        </Wrapper02>
    );
};

export default Chatting;
